import React from 'react';
import PropTypes from 'prop-types';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Box,
	Chip,
	Typography,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import InfosocIcon from './InfosocIcon';
import DialogClose from './DialogClose';

function FeaturesDialog({ open, onClose, currentUser }) {
	const FeatureItem = ({ label, description, isEnabled, iconName, ...props }) => (
		<ListItem {...props}>
			<ListItemIcon sx={{ minWidth: 44 }}>
				<InfosocIcon type={iconName} />
			</ListItemIcon>
			<ListItemText primary={label} secondary={description} style={{ marginRight: 8 }} />
			<ListItemIcon>
				<Chip
					label={
						<Typography variant='body2' width={40} textAlign={'center'}>
							{isEnabled ? 'Aktiv' : 'Inaktiv'}
						</Typography>
					}
					icon={isEnabled ? <CheckCircleIcon /> : <CancelIcon />}
					color={isEnabled ? 'success' : 'default'}
					variant='outlined'
				/>
			</ListItemIcon>
		</ListItem>
	);

	if (!currentUser) {
		return null;
	}

	const FeatureItems = [
		{
			label: 'E-litteratur',
			isEnabled: currentUser.featureELiterature,
			iconName: 'ebook',
		},
		{
			label: 'Lagkommentarer',
			isEnabled: currentUser.featureLegalComments,
			iconName: 'legalcomment',
		},
		{
			label: 'Rättsfall Plus',
			isEnabled: currentUser.featureSbtPlus,
			iconName: 'sbt_plus',
		},
	];

	return (
		<Dialog open={open} onClose={onClose} scroll='paper'>
			<DialogTitle id='scroll-dialog-title'>
				Plusfunktioner
				<DialogClose onClose={() => onClose()} />
			</DialogTitle>
			<DialogContent dividers>
				<Typography variant='body1' gutterBottom pr={2} pl={2} maxWidth={380}>
					Här kan du se vilka plusfunktioner som är aktiverade för ditt konto.
				</Typography>
				<Box m={2}>
					<List>
						{FeatureItems.map((feature, index) => (
							<FeatureItem
								key={index}
								label={feature.label}
								isEnabled={feature.isEnabled}
								iconName={feature.iconName}
							/>
						))}
					</List>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button type='outlined' onClick={onClose}>
					Stäng
				</Button>
			</DialogActions>
		</Dialog>
	);
}

FeaturesDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	currentUser: PropTypes.object.isRequired,
};

export default FeaturesDialog;
